import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            redirect: {
                name: 'home'
            },
        },
        {
            path: '/privacy',
            name: 'privacy',
        },
        {
            path: '/privacy.html',
            name: 'privacy.html',
        },
        {
            path: '/device_permissions',
            name: 'device_permissions',
        },
        {
            path: '/device_permissions.html',
            name: 'device_permissions.html',
        },
        //更多礼包
        {
            path: '/gift',
            name: 'gift',
            component: () => import("../components/gift/index.vue")
        },
        //礼包详情
        {
            path: '/giftDetail',
            name: 'giftDetail',
            component: () => import("../components/giftDetail/index.vue")
        },
        //礼包详情
        {
            path: '/information',
            name: 'information',
            component: () => import("../components/information/index.vue")
        },
        {
            path: '/customerCenter',
            name: 'center',
            component: () => import("../components/customer/center/index.vue")
        },
        {
            path: '/customer',
            name: 'customer',
            component: () => import("../components/customer/index.vue")
        },
        {
            path: '/home',
            name: 'home',
            component: () => import("../components/home/index.vue")
        }, {
            path: '/detail',
            name: 'detail',
            component: () => import("../components/detail/index.vue")
        },
        {
            path: '/game',
            name: 'game',
            component: () => import("../components/game/index.vue")
        },
        {
            path: '/game-list',
            name: 'gameList',
            component: () => import("../components/game-list/index.vue")
        },
        {
            path: '/gameDetail',
            name: 'gameDetail',
            component: () => import("../components/gameDetail/index.vue")
        },
        {
            path: '/right',
            name: 'right',
            component: () => import("../components/common/right/index.vue")
        },
        // {
        //   path: '/phoneLogin',
        //   name: 'phoneLogin',
        //   component: () => import("../components/login/phone/index.vue")
        // },
        {
            path: '/test',
            name: 'test',
            component: () => import("../components/test/index.vue")
        },
        // {
        //   path: '/forget',
        //   name: 'forget',
        //   component: () => import("../components/login/forgetPwd/index.vue")
        // },
        {
            path: '/login',
            name: 'login',
            component: () => import("../components/login/index.vue")
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js